<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-2">
          <div class="ml-10">
            Week {{ week_index + 1 }} of {{ weeks.length }}
          </div>
        </div>
        <div class="col-6">
          <button id="prev" @click="_prev" class="btn btn-plt">
            &lt;
          </button>
          <button id="next" @click="_next" class="btn btn-plt">
            &gt;
          </button>
        </div>
        <div class="col-4">
          <button id="new_round" @click="_new_round" class="btn btn-plt">
            New Round
          </button>
          <button id="copy" @click="_copy" class="btn btn-plt">
            Copy
          </button>
          <button id="save" @click="_save" class="btn btn-plt">
            Save
          </button>
          <button id="reset" @click="_reset" class="btn btn-plt">
            Reset
          </button>
        </div>
      </div>
    </div>

    <JobWeekDisplay
      v-for="week in weeks"
      v-bind:key="week.id"
      class="col-12"
      :week_index="week.index"
      :schedule_index="schedule_index"
      v-show="week.index == week_index"
    />
    <JobCustomerSelection
      class="col-12"
      v-if="showNewRoundModal"
      @save="_save_new_job"
      @close="_close_round_popup"
      @delete="_close_round_popup"
      :schedule_index="schedule_index"
      :schedule_round="round"
      :available_jobs="available_jobs"
      :copy_enabled="false"
    />
    <ScheduleWeekCopyModal
      v-if="showCopyWeekModal"
      :schedule_index="schedule_index"
      :week_index="week_index"
      @close="_toggleShowCopyWeekModal"
    />
  </div>
</template>

<script>
import JobWeekDisplay from "@/components/job/JobWeekDisplay.vue";
import JobCustomerSelection from "@/components/job/JobCustomerSelection.vue";
import ScheduleWeekCopyModal from "@/components/job/ScheduleWeekCopyModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManageSchedule",
  props: {
    schedule_index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    round: null,
    loading: false,
    week_index: -1,
    weeks: [],
    showNewRoundModal: false,
    showCopyWeekModal: false,
    tab: 0,
  }),
  computed: {
    ...mapState("schedule", [
      "schedules",
      "schedule_group_weeks",
      "available_jobs",
      "next_schedule_round_tmp_id",
    ]),
    ...mapState("status", ["round_to_copy"]),
  },
  watch: {
    round_to_copy(new_value) {
      if (new_value != null) {
        this.showNewRoundModal = true;
        this.nextTmpScheduleRoundId(),
          (this.round = {
            id: this.next_schedule_round_tmp_id,
            round: new_value.round,
            active: true,
            day_index: new_value.day_index,
            personnels: new_value.personnels,
            round_id: new_value.round_id,
            schedule_id: new_value.schedule_id,
            sequence_order: new_value.sequence_order,
            vehicle: new_value.vehicle,
            vehicle_id: new_value.vehicle_id,
            week_index: new_value.week_index,
            changes: [],
          });
        this.clear_copy_round();
      }
    },
    schedule_group_weeks(new_value) {
      if (new_value[this.schedule_index] !== undefined) {
        this.weeks = new_value[this.schedule_index];
      } else {
        this.weeks = [];
      }
    },
    schedule_index(new_value) {
      if (this.schedule_group_weeks[new_value] !== undefined) {
        this.weeks = this.schedule_group_weeks[new_value];
      } else {
        this.weeks = [];
      }
      if (this.week_index < 0) {
        this.week_index = 0;
      } else if (this.week_index > this.weeks.length - 1) {
        this.week_index = this.weeks.length - 1;
      }
    },
  },
  methods: {
    ...mapActions("schedule", [
      "getSchedule",
      "saveSchedule",
      "nextTmpScheduleRoundId",
    ]),
    ...mapActions("status", [
      "enable_job_dragging",
      "disable_job_dragging",
      "clear_copy_round",
    ]),
    mounted() {
      this._reset();
    },
    _loadWeek() {
      this.getSchedule();
    },
    _save() {
      this.saveSchedule();
    },
    _copy() {
      this._toggleShowCopyWeekModal();
    },
    _toggleShowCopyWeekModal() {
      this.showCopyWeekModal = !this.showCopyWeekModal;
    },
    _new_round() {
      this.nextTmpScheduleRoundId(),
        (this.round = {
          id: this.next_schedule_round_tmp_id,
          round: {
            id: 0,
            name: "",
            area: "",
            jobs: [],
            active: true,
            fixed: false,
          },
          active: true,
          day_index: -1,
          week_index: -1,
          vehicle_id: -1,
          vehicle: null,
          sequence_order: 1, // todo use count of rounds in that day
          schedule_id: this.schedule ? this.schedule.id : -1,
          personnels: [],
          round_id: 0,
          changes: [],
        });
      this.disable_job_dragging();
      this.showNewRoundModal = true;
    },
    _reset() {
      this._loadWeek();
    },
    _close_round_popup() {
      this.showNewRoundModal = false;
      this.enable_job_dragging();
    },
    _save_new_job() {
      this.showNewRoundModal = false;
      this.enable_job_dragging();
    },
    _select_date() {},
    _next() {
      if (this.week_index < this.weeks.length - 1) {
        this.week_index += 1;
      }
    },
    _prev() {
      if (this.week_index > 0) {
        this.week_index -= 1;
      }
    },
    open_round(schedule_index, week_index, round) {
      round.week_index = week_index;
      round.schedule_id = this.schedules[schedule_index].id;
      this.round = round;
      this.showNewRoundModal = true;
      this.disable_job_dragging();
    },
  },
  components: {
    JobWeekDisplay,
    JobCustomerSelection,
    ScheduleWeekCopyModal,
  },
};
</script>
